import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=2d6cd662&scoped=true"
import script from "./UsersEdit.vue?vue&type=script&lang=js"
export * from "./UsersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6cd662",
  null
  
)

export default component.exports